var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.8,
    height: 16.851,
    viewBox: "0 0 8.8 16.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_38",
    "data-name": "Trazado 38",
    d: "M85.711,16.851V9.175h2.621l.374-3h-3V4.306c0-.843.281-1.5,1.5-1.5H88.8V.094C88.426.094,87.489,0,86.46,0a3.614,3.614,0,0,0-3.838,3.932V6.179H80v3h2.621v7.677Z",
    transform: "translate(-80)",
    fill: "#e73758",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.dbbaf7cbf46c6a4057281e8ed23a1ca0.svg";
export { ForwardRef as ReactComponent };